module.exports = __webpack_public_path__ + "3035cbed1bbfca80f8dec341a0132928.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 28
// module chunks = 0